import { DEFAULT_TRACK, type ChallengeEligibility, type LeaderRow, type MyChallenge } from "@core/economy/challengeTracks";
import { apiFetch } from "../lib/api";

export async function fetchMyChallenge(): Promise<MyChallenge | null> {
  const res = await apiFetch<{ ok: boolean; result: MyChallenge | null }>("/api/mobile/challenge");
  if (!res?.ok || res.result === undefined) throw new Error("기록 미션 조회 실패");
  return res.result;
}

export async function joinChallenge(track = DEFAULT_TRACK): Promise<{ ok: boolean; error?: string } | undefined> {
  const res = await apiFetch<{ ok: boolean; result: { ok: boolean; error?: string } }>(
    "/api/mobile/challenge",
    { method: "POST", body: { track } },
  );
  return res?.result;
}

export async function fetchChallengeBoard(seasonId?: string): Promise<LeaderRow[]> {
  const qs = seasonId ? `?season=${seasonId}` : "";
  const res = await apiFetch<{ ok: boolean; result: LeaderRow[] }>(`/api/mobile/challenge/board${qs}`);
  return Array.isArray(res?.result) ? res.result : [];
}

export async function fetchChallengeEligibility(track = DEFAULT_TRACK): Promise<ChallengeEligibility> {
  const res = await apiFetch<{ ok: boolean; result: ChallengeEligibility }>(
    `/api/mobile/challenge/eligibility?track=${encodeURIComponent(track)}`,
  );
  if (!res?.ok || !res.result || typeof res.result.can_join !== "boolean") {
    throw new Error("기록 미션 적격성 조회 실패");
  }
  return res.result;
}
